module.exports = __webpack_public_path__ + "media/zakupy_zero.a603cf30.mp3";